<template>
  <!-- FIXME - RENAME ME TO SOMETHING THAT MAKES MORE SENSE PLEASE -->
  <div class="detailsView flexRow">
    <!-- <h2>{{ header }}</h2> -->
    <day-summary class="daySummary" :categories="categories" />

    <the-line v-if="isBetaUser && !isMobile()" :categories="categories" />

    <!-- TODO - FIX STYLING/CSS ISSUES ACROSS RANGE OF SIZES AND NUMBER OF BLOCKS -->
    <!-- DON"T ALLOW THINGS TO GROW TO THEIR HEARTS CONTENT WITHOUT APPROVAL -->

    <category-details class="categoryDetailsSummary" :categoryId="category.id" />

    <quotes class="quotes" />
    <!--     <ul>
      <li>Include stats on last block, blocks per week, averages, etc.</li>
      <li>Number of hours/blocks that remain in the day</li>
      <li>Add new category trigger/menu</li>
      <li>Category details on click + edit options</li>
      GET LAST ACTIVITY
    </ul> -->
  </div>
</template>

<script>
import DaySummary from "../components/DaySummary.vue";
import TheLine from "../components/TheLine.vue";
import CategoryDetails from "../components/CategoryDetails.vue";
import Quotes from "../components/Quotes.vue";

import util from "../util.js";
import auth from "../auth.js";
import categoryUtil from "../categoryUtil.js";
import eventHub from "../eventHub.js";

export default {
  name: "details-view",
  mixins: [util.getMobileMixin()],
  components: {
    "day-summary": DaySummary,
    TheLine,
    "category-details": CategoryDetails,
    quotes: Quotes,
  },
  props: ["categories"],
  data() {
    return {
      category: {},
    };
  },
  created() {
    // FIXME - DEFAULT VIEW TO SOMETHING USEFUL RATHER THAN BEING BLANK
    eventHub.$on("category-details-block-clicked", this.showCategoryDetails);
  },
  methods: {
    showCategoryDetails(data) {
      const categoryId = data.id;
      this.category = categoryUtil.getCategory(categoryId);
    },
  },
  computed: {
    // FIXME - Move to TodayView
    header() {
      return moment(util.getCurrentDay(), util.dateString).format("MMMM Do, YYYY");
    },
    isBetaUser: () => auth.isBetaUser(),
  },
};
</script>

<style scoped>
.detailsView {
  height: 100%;
  position: fixed;
  /*width: 50%;*/
  /*max-height: 800px;*/
  height: calc(100vh - 2rem);
}

.detailsView.flexRow {
  flex-direction: column;
  flex-wrap: nowrap; /* FIXME - This hides some elements in some situations... */
  max-width: 600px;
}

h2,
.daySummary {
  flex-grow: 0;
}

h2 {
  margin-top: 1.75rem;
}

.categoryDetailsSummary {
  margin-top: 1rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
  min-width: 380px;
  flex-grow: 1;
  max-height: 800px; /* FIXME - REMOVE AFTER WE LIMIT BLOCKGRAPH HEIGHTS*/
}

.quotes {
  margin: 2rem;
}

@media (max-width: 600px) {
  .detailsView.flexRow {
    bottom: 0;
    left: 0;
    right: 0;
    height: 4rem;
    border-top: 1px solid #eee;
    background-color: white;
    flex-direction: row-reverse;
  }

  .categoryDetailsSummary {
    border-top: none;
    margin-top: 0.5rem;
    padding: 0;
    min-width: auto;
  }

  /* FIXME - MAKE THIS CLEANER PLEASE - DONT HAVE UNUSED COMPONENTS RENDERED AT ALL */
  .quotes {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// DetailsView.vue?654b82f2